export default {
	methods: {
		addErrors(result) {
            if(typeof result.response.data.errors != 'undefined') {
                for(let key in result.response.data.errors) {
                    if(typeof result.response.data.errors[key][0] != 'undefined') {
						this.$set(this.errors, key, result.response.data.errors[key][0]);
					}
                }
			}
		},
		hasErrors(result) {
			if(typeof result.response.data.errors != 'undefined') {
				return true;
			}
			return false;
		},
		clearErrors() {
			this.errors = {};
		},
	}
}


// WEBPACK FOOTER //
// ./src/mixins/validationErrors.js